// extracted by mini-css-extract-plugin
export var dropdown = "_hg-0";
export var imagePlaceholder = "_hg-2";
export var imageWrapper = "_hg-3";
export var productImage = "_hg-1";
export var truncateContainer = "_hg-4";
export var truncateText = "_hg-5";